import { FC, memo } from 'react';
import { twJoin } from 'tailwind-merge';
import { useModalContext } from 'src/hooks/useModalContext';
import { CloseModal } from '../ModalWrapper/CloseModal';

interface FullScreenModalWrapperProps {
  children: React.ReactNode;
  className?: string;
  onClose?: () => void;
  showCross?: boolean;
  crossAdditionalClassName?: string;
}

const _FullScreenModalWrapper: FC<FullScreenModalWrapperProps> = ({
  className,
  children,
  onClose,
  showCross = true,
  crossAdditionalClassName
}) => {
  const { modalProps, closeModal } = useModalContext<{
    onClose?: () => void;
  }>();
  const handleClose = () => {
    closeModal(); // основная функция которая закрывает модальное окно в контексте модальных окон
    onClose?.(); // функция переданная из компонента конкретного модального окна
    modalProps?.onClose?.(); // функция-коллбэк переданная в момент открытия модального окна
  };

  return (
    <div
      className={twJoin(
        'fixed z-[900] bg-lm_bg inset-0 overflow-auto flex flex-col justify-start items-center',
        className
      )}>
      {showCross && (
        <div className="w-full flex justify-end items-center">
          <CloseModal onClose={handleClose} className={crossAdditionalClassName} />
        </div>
      )}
      {children}
    </div>
  );
};

export const FullScreenModalWrapper = memo(_FullScreenModalWrapper);
